<div class="page d-flex justify-content-center align-items-center">    
    <div class="w-75 align-items-center">
      <mat-progress-bar
                [mode]="'indeterminate'">
      </mat-progress-bar>
    </div>
</div>
